import styled from "styled-components";
import { Box, Flex, Text } from "rebass/styled-components";

export const PlayersList = styled(Box)`
  display: flex;
  flex: 0 0 400px;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  min-width: 200px;

  @media (max-width: 1620px) and (min-width: 1321px) {
    flex: 0 0 320px;
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
  }
`;

export const PlayerItem = styled(Flex)<{ isFirst?: boolean }>`
  align-items: center;
  border-bottom: ${({ isFirst, theme }) =>
    isFirst ? `1px solid ${theme.colors.navy50}` : "none"};
  gap: 12px;
  padding: 8px 0;

  @media (max-width: 1620px) and (min-width: 1321px) {
    gap: 8px;
    padding: 6px 0;
  }
`;

export const PlayerRank = styled(Text)<{ rank: number; numberSize: string }>`
  color: ${({ rank, theme }) =>
    rank === 1 ? theme.colors.error : theme.colors.envy};
  font-size: ${({ numberSize }) => numberSize};
  font-weight: 800;
  min-width: 24px;
`;

export const PlayerInfo = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
`;

export const PlayerName = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 14px;
  font-weight: 600;
`;

export const CustomFollowButton = styled(Box)`
  button {
    border-radius: 20px !important;
    font-size: 12px !important;
    height: 28px !important;
    min-width: 80px !important;
    padding: 0 12px !important;

    > svg {
      display: none !important;
    }

    gap: 0 !important;
  }
`;
